import Mock from 'mockjs'
import orangnizationAPI from './mockdata/test' // 引入定义数据格式的文件
import visitReserve from './mockdata/visit_reserve'
import consultFiles from './mockdata/consult_files'
//        接口里的地址   请求方式    mock中对应的返回
Mock.mock(/\/org\/list/, 'get', orangnizationAPI.getOrgList)
Mock.mock(/\/org/, 'put', orangnizationAPI.createOrg)
Mock.mock(/\/org/, 'post', orangnizationAPI.updateOrg)
Mock.mock(/\/org\/delete/, 'put', orangnizationAPI.orgDelete)

// mock参观预约接口
// Mock.mock(/\/visit_ascertained_time/, 'get', visitReserve.getVisitTime)
// Mock.mock(/\/change_exhibition_room/, 'get', visitReserve.getExhibtionRoom)
// Mock.mock(/\/visit_reserve/, 'post', visitReserve.submitVisitReserve)
Mock.mock(/\/visit_reserve_select/, 'get', visitReserve.selectVisit)
Mock.mock(/\/visit_reserve_del/, 'get', visitReserve.delVisit)

// mock查档预约接口
Mock.mock(/\/consult_files_time/, 'get', consultFiles.getConsultTime)
Mock.mock(/\/consult_files_message/, 'post', consultFiles.submitConsultFiles)
Mock.mock(/\/consult_files_select/, 'get', consultFiles.selectConsult)
Mock.mock(/\/consult_files_del/, 'get', consultFiles.delConsult)

export default Mock